// removed by extract-text-webpack-plugin
module.exports = {"loader":"loading-screen__loader___2Knk1 globals__loader___Dpwks"};


//////////////////
// WEBPACK FOOTER
// ./src/components/loader/loading-screen.scss
// module id = 660
// module chunks = 0